module.exports = __webpack_public_path__ + "img/hw-s12.60f6b652.svg";